const BASE_URL =
	process.env.REACT_APP_BASE_URL || "http://staging.bkoih3.ml:9191/api";

export const AUTH = {
	LOGIN_API: `${BASE_URL}/auth/login`,
	GET_USER_API: `${BASE_URL}/auth/me`,
	LOGOUT_API: `${BASE_URL}/auth/logout`,
};
